<template>
  <main class="about-us">
    <b-container fluid class="header">
      <b-row>
        <b-col>
          <h1 class="title">Privacy Policy</h1>
          <!-- <img src="@/assets/rebrand/about/about-title.png" alt="about" class="img-about-title" /> -->
          <!-- <h1 class="title">
            SNKRHUD is the next <br />
            evolution in sneaker <br />collecting.
          </h1> -->
        </b-col>
      </b-row>
      <b-row class="introduction">
        <article>
          <p>
            SNKRHUD, INC. (‘SNKRHUD” or “we”) builds upon decades of passion for sneakers,
            streetwear, and culture. Designed as a playground for creatives, a center of knowledge
            for sneakerheads new and old, and the epicenter of the next revolution in sneaker
            collecting. Building an NFT-based community with a play-to-earn gaming component is
            about much more than flexing, but rather empowering our Residents to build their own
            sneaker legacies.As part of our community, please first carefully read our Terms of
            Service (“Terms”).
          </p>
          <p>
            These Terms govern any access or use of the website at https://snkrhud.com/,
            https://sneakerrater.com/, and any other web site, mobile application, marketplace or
            application program interface operated or made available by SNKRHUD (the “Platform”) as
            well as any services provided on or through the Platform (“Services”). By using our
            Services, you agree to these Terms. If you do not agree to these Terms, do not use our
            Services.
          </p>
          <p>
            We may make changes to these Terms from time to time. If we make changes, we will
            provide you with notice of such changes, such as by sending an email, providing a notice
            through our Services or updating the date at the top of these Terms. Unless we say
            otherwise in our notice, the amended Terms will be effective immediately, and your
            continued use of our Services after we provide such notice will confirm your acceptance
            of the changes. If you do not agree to the amended Terms, you must stop using our
            Services.
          </p>
          <p class="questions">
            If you have any questions about these Terms or our Services, please contact us at
            help@snkrhud.com.
          </p>
        </article>
      </b-row>
      <!-- <b-row>
        <b-col>
          <p class="about-desc -wb">
            An online neighborhood for sneakerheads, the SNKRHUD platform lets people immortalize
            their <br />collections as digital collectibles. SNKRHUD's mission is driven by the
            shared passion for sneakers, not <br />just the value they hold. In this space, it's not
            about studio- produced footwear images, it's about <br />
            personal photos customized to highlight the unique features of a well-loved pair of
            kicks. <br /><br />

            The platform is broken into three distinct pillars: <b>CREATE</b>, <b>COLLECT</b>, and
            <b>COMBAT</b>, allowing sneakerheads <br />at various levels of the game to interact
            with and monetize their sneakers in an entirely new way. <br /><br />

            Showcase your favorite sneakers, invite friends, and connect with other sneakerheads.
            Explore <br />SNKRHUD'S many features including turning your physical sneakers into
            digital collectibles, an NFT <br />ecosystem , and a growing community of sneakerheads.
          </p>
          <p class="about-desc -mb">
            An online neighborhood for <br />
            sneakerheads, the SNKRHUD platform lets <br />
            people immortalize their collections as <br />digital collectibles. SNKRHUD's mission is
            <br />driven by the shared passion for sneakers, <br />not just the value they hold. In
            this <br />space, it's not about studio- produced <br />footwear images, it's about
            personal <br />photos customized to highlight the <br />unique features of a well-loved
            pair <br />of kicks. <br /><br />

            The platform is broken into three distinct <br />
            pillars: <b>CREATE</b>, <b>COLLECT</b>, and <b>COMBAT</b>, <br />allowing sneakerheads
            at various levels <br />of the game to interact with and<br />
            monetize their sneakers in an entirely<br />
            new way. <br /><br />

            Showcase your favorite sneakers, invite <br />friends, and connect with other
            <br />sneakerheads. Explore SNKRHUD'S many <br />features including turning your
            physical <br />sneakers into digital collectibles, an NFT <br />ecosystem , and a
            growing community of <br />sneakerheads.
          </p>
        </b-col>
      </b-row> -->
      <div class="about-bg" />
    </b-container>
    <b-container fluid class="content position-relative">
      <img
        src="@/assets/rebrand/about/founders-divider.png"
        alt="founder divider"
        class="founder-divider"
      />
      <b-row class="">
        <article class="definitions">
          <h3 class="title">1. Definitions</h3>
          <p class="">
            “Art” means any art, design, and drawings that may be associated with an NFT that you
            Own.
          </p>
          <p>"NFT" means any blockchain-tracked, non-fungible token.</p>
          <p>
            “Own” means, with respect to an NFT, an NFT that you have purchased or otherwise
            rightfully acquired from a legitimate source, where proof of such purchase is recorded
            on the relevant blockchain.
          </p>
          <p>
            “Extensions” means third party designs that: (i) are intended for use as extensions or
            overlays to the Art, (ii) do not modify the underlying Art, and (iii) can be removed at
            any time without affecting the underlying Art.
          </p>
          <p>“Digital Collectible” is an NFT and any Extensions.</p>
          <p>“Purchased NFT” means an NFT that you Own.</p>
          <p>
            “Third Party IP” means any third party patent rights (including, without limitation,
            patent applications and disclosures), copyrights, trade secrets, trademarks, know-how or
            any other intellectual property rights recognized in any country or jurisdiction in the
            world.
          </p>
        </article>
        <article class="ownership">
          <h3 class="title">2. Ownership</h3>
          <p>
            You acknowledge and agree that SNKRHUD (or, as applicable, its licensors) owns all legal
            right, title and interest in and to the Art, and all intellectual property rights
            therein. The rights that you have in and to the Art are limited to those described in
            this License. SNKRHUD reserves all rights in and to the Art not expressly granted to you
            in this License.
          </p>
        </article>
        <article class="license">
          <h3 class="title">3. License</h3>
          <p>
            General Use. Subject to your continued compliance with the terms of this License,
            SNKRHUD grants you a worldwide, non-exclusive, non-transferable, royalty-free license to
            use, copy, and display the Art for your Purchased NFTs, along with any Extensions that
            you choose to create or use, solely for the following purposes: (i) for your own
            personal, non-commercial use; (ii) as part of a marketplace that permits the purchase
            and sale of your NFTs, provided that the marketplace cryptographically verifies each NFT
            owner’s rights to display the Art for their Purchased NFTs to ensure that only the
            actual owner can display the Art; or (iii) as part of a third party website or
            application that permits the inclusion, involvement, or participation of your NFTs,
            provided that the website/application cryptographically verifies each NFT owner’s rights
            to display the Art for their Purchased NFTs to ensure that only the actual owner can
            display the Art, and provided that the Art is no longer visible once the owner of the
            Purchased NFT leaves the website/application.
          </p>
          <p>
            Commercial Use. Subject to your continued compliance with the terms of this License,
            SNKRHUD grants you a limited, worldwide, non-exclusive, non-transferable license to use,
            copy, and display the Art for your Purchased NFTs for the purpose of commercializing
            your own merchandise that includes, contains, or consists of the Art for your Purchased
            NFTs (“Commercial Use”), provided that such Commercial Use does not result in you
            earning more than Two Hundred Fifty Thousand Dollars ($250,000) in gross revenue each
            year. For the sake of clarity, nothing in this Section 3.b will be deemed to restrict
            you from (i) owning or operating a marketplace that permits the use and sale of NFTs
            generally, provided that the marketplace cryptographically verifies each NFT owner’s
            rights to display the Art for their Purchased NFTs to ensure that only the actual owner
            can display the Art; (ii) owning or operating a third party website or application that
            permits the inclusion, involvement, or participation of NFTs generally, provided that
            the third party website or application cryptographically verifies each NFT owner’s
            rights to display the Art for their Purchased NFTs to ensure that only the actual owner
            can display the Art, and provided that the Art is no longer visible once the owner of
            the Purchased NFT leaves the website/application; or (iii) earning revenue from any of
            the foregoing, even where such revenue is in excess of $250,000 per year.
          </p>
        </article>
        <article class="restrictions">
          <h3 class="title">4. Restrictions</h3>
          <p>
            You agree that you may not, nor permit any third party to do or attempt to do any of the
            foregoing without SNKRHUD’s express prior written consent in each case: (i) modify the
            Art for your Purchased NFT in any way, including, without limitation, the shapes,
            designs, drawings, attributes, or color schemes (your use of Extensions will not
            constitute a prohibited modification hereunder); (ii) use the Art for your Purchased
            NFTs to advertise, market, or sell any third party product or service; (iii) use the Art
            for your Purchased NFTs in connection with images, videos, or other forms of media that
            depict hatred, intolerance, violence, cruelty, or anything else that could reasonably be
            found to constitute hate speech or otherwise infringe upon the rights of others; (iv)
            use the Art for your Purchased NFTs in movies, videos, or any other forms of media,
            except to the limited extent that such use is expressly permitted in Section 3(b) above
            or solely for your own personal, non-commercial use; (v) sell, distribute for commercial
            gain (including, without limitation, giving away in the hopes of eventual commercial
            gain), or otherwise commercialize merchandise that includes, contains, or consists of
            the Art for your Purchased NFTs, except as expressly permitted in Section 3(b) above;
            (vi) attempt to trademark, copyright, or otherwise acquire additional intellectual
            property rights in or to the Art for your Purchased NFTs; or (vii) otherwise utilize the
            Art for your Purchased NFTs for your or any third party’s commercial benefit. To the
            extent that Art associated with your Purchased NFTs contains Third Party IP (e.g.,
            licensed intellectual property from a celebrity, athlete, or other public figure), you
            understand and agree as follows: (w) that you will not have the right to use such Third
            Party IP in any way except as incorporated in the Art, and subject to the license and
            restrictions contained herein; (x) that the Commercial Use license in Section 3(b) above
            will not apply; (y) that, depending on the nature of the license granted from the owner
            of the Third Party IP, SNKRHUD may need to pass through additional restrictions on your
            ability to use the Art; and (z) to the extent that SNKRHUD informs you of such
            additional restrictions in writing (email is permissible), you will be responsible for
            complying with all such restrictions from the date that you receive the notice, and that
            failure to do so will be deemed a breach of this license. The restriction in Section 4
            will survive the expiration or termination of this License.
          </p>
        </article>
        <article class="terms-of-license">
          <h3 class="title">5. Terms of License</h3>
          <p>
            The license granted in Section 3 above applies only to the extent that you continue to
            Own the applicable Purchased NFT. If at any time you sell, trade, donate, give away,
            transfer, or otherwise dispose of your Purchased NFT for any reason, the license granted
            in Section 3 will immediately expire with respect to those NFTs without the requirement
            of notice, and you will have no further rights in or to the Art for those NFTs. If you
            exceed the $250,000 limitation on annual gross revenue set forth in Section 3.b above,
            you will be in breach of this License, and must send an email to SNKRHUD at
            help@snkrhud.com within fifteen (15) days, with the phrase “NFT License - Commercial
            Use” in the subject line, requesting a discussion with SNKRHUD regarding entering into a
            broader license agreement or obtaining an exemption (which may be granted or withheld in
            SNKRHUD’s sole and absolute discretion). If you exceed the scope of the license grant in
            Section 3.b without entering into a broader license agreement with or obtaining an
            exemption from SNKRHUD, you acknowledge and agree that: (i) you are in breach of this
            License; (ii) in addition to any remedies that may be available to SNKRHUD at law or in
            equity, the Creator may immediately terminate this License, without the requirement of
            notice; and (iii) you will be responsible to reimburse SNKRHUD for any costs and
            expenses incurred by SNKRHUD during the course of enforcing the terms of this License
            against you.
          </p>
        </article>
        <article class="nft-creation">
          <h3 class="title">6. NFT Creation</h3>
          <p>
            You are solely responsible for your use of our Services and for any information you
            provide, including compliance with applicable laws, rules, and regulations, as well as
            these Terms. By using our Services in conjunction with creating, submitting, posting,
            promoting, or displaying content, or by complying with SNKRHUD’s metadata standards in
            your metadata API responses, you grant us a worldwide, non-exclusive, sublicensable,
            royalty-free license to use, copy, modify, and display any content, including but not
            limited to text, materials, images, files, communications, comments, feedback,
            suggestions, ideas, concepts, questions, data, or otherwise, that you submit or post on
            or through our Services for our current and future business purposes, including to
            provide, promote, and improve our Services. This includes any digital file, art, or
            other material linked to or associated with any NFT’s that are displayed on our
            Services.
          </p>
          <p>
            SNKRHUD does not claim that submitting, posting, or displaying this content on or
            through our Services gives SNKRHUD any ownership of the content. We're not saying we own
            it. We're just saying we might use it and show it off a bit.
          </p>
          <p>
            You represent and warrant that you have, or have obtained, all rights, licenses,
            consents, permissions, power and/or authority necessary to grant the rights granted
            herein for any content that you create, submit, post, promote, or display on or through
            our Services. You represent and warrant that such content does not contain material
            subject to copyright, trademark, publicity rights, or other intellectual property
            rights, unless you have necessary permission or are otherwise legally entitled to post
            the material and to grant SNKRHUD the license described above, and that the content does
            not violate any laws.
          </p>
          <p>
            SNKRHUD will take down works in response to Digital Millennium Copyright Act (“DMCA”)
            takedown notices and/or other intellectual property infringement claims and will
            terminate a user's access to our Services if the user is determined to be a repeat
            infringer. If you believe that your content has been copied in a way that constitutes
            copyright or trademark infringement, or violates your publicity or other intellectual
            property rights, please contact help@snkrhud.com. For us to process your infringement
            claim regarding content on our Services, you must be the rightsholder or someone
            authorized to act on behalf of the rightsholder. When contacting us, your notice must
            include:
          </p>
          <ul>
            <li>
              Identification of the copyrighted work(s), trademark, publicity rights, or other
              intellectual property rights that you claim is being infringed;
            </li>
            <li>
              Identification of the allegedly infringing material that is requested to be removed,
              including a description of the specific location (i.e., urls) on our Services of the
              material claimed to be infringing, so that we may locate the material;
            </li>
            <li>
              Your contact information – at a minimum, your full legal name (not pseudonym) and
              email address;
            </li>
            <li>A declaration that contains all of the following:</li>
            <ul>
              <li>
                A statement that you have a good faith belief that use of the material in the manner
                complained of is not authorized by the intellectual property rights owner, its
                agent, or the law;
              </li>
              <li>A statement that the information in the notice is accurate; and</li>
              <li>
                A statement under penalty of perjury that you are authorized to act on behalf of the
                intellectual property owner of the intellectual property that is allegedly being
                infringed.
              </li>
            </ul>
            <li>Your physical or electronic signature (of your full legal name).</li>
          </ul>
          <p>
            Please note that we will forward your notice of intellectual property infringement,
            including your contact information, to the party who will have their content removed so
            they understand why it is no longer available on SNKRHUD and can also contact you to
            resolve any dispute.
          </p>
        </article>
        <article class="eligibility">
          <h3 class="title">7. Eligibility</h3>
          <p>In order to use our Services, you must meet the following eligibility criteria:</p>
          <ul>
            <li>
              You must not be located in a country that is subject to the United States government
              embargo, or that has been designated by the United States government as a "terrorist
              supporting" country.
            </li>
            <li>
              You must not be listed on any United States government list of prohibited or
              restricted parties.
            </li>
            <li>You must be at least 13 years of age.</li>
          </ul>
          <p>
            If you are under 18 years of age (or the age of legal majority where you live), you may
            use our Services only under the supervision of a parent or legal guardian who agrees to
            be bound by these Terms. If you are a parent or legal guardian of a user under the age
            of 18 (or the age of legal majority), you agree to be fully responsible for the acts or
            omissions of such user in relation to our Services. If you use our Services on behalf of
            another person or entity, (a) all references to "you" throughout these Terms will
            include that person or entity, (b) you represent that you are authorized to accept these
            Terms on that person’s or entity’s behalf, and (c) in the event you or the person or
            entity violates these Terms, both you and the person or entity agree to be responsible
            to us.
          </p>
        </article>
        <article class="user-account-and-security">
          <h3 class="title">8. Your User Account and Account Security</h3>
          <p>
            You need to register for an account to access our Services. When you register for an
            account, you must provide accurate account information and promptly update this
            information if it changes. You also must maintain the security of your account and
            promptly notify us if you discover or suspect that someone has accessed your account
            without your permission. You must not permit others to use your account credentials. You
            are responsible for the activities of any users that occur in connection with your
            account. We reserve the right to reclaim usernames, including on behalf of businesses or
            individuals that hold legal claim, including trademark rights, in those usernames.
          </p>
          <p>
            Access to your account is limited solely to you. You will not sell, rent, lease, or
            grant access to your account to any person without our prior written permission.
          </p>
          <p>
            You are solely responsible for maintaining the security of your account and control over
            any usernames, passwords, or any other codes that you use to access our Services. You
            will not hold us responsible for managing and maintaining the security of your account.
            We are not responsible (and you will not hold us responsible) for any unauthorized
            access to or use of your account. You are responsible for monitoring your account. If
            you notice any unauthorized or suspicious activity in your account, please notify us
            immediately.
          </p>
        </article>
        <article class="suspenion-of-account">
          <h3 class="title">9. Suspension of Account</h3>
          <p>
            We have the right to immediately suspend your account, pause or cancel your access to
            our Services, or close your account if we suspect, in our sole discretion, that (a) your
            account is being used for money laundering, to evade sanctions or to engage in illegal
            activity, (b) you have concealed or provided false identification information or other
            details, (c) you have engaged in fraudulent activity, or (d) you have engaged in
            transactions in violation of these Terms.
          </p>
        </article>
        <article class="trademarks">
          <h3 class="title">10. Trademarks</h3>
          <p>
            SNKRHUD and our logos, our product or service names, our slogans and the look and feel
            of our Services are trademarks of SNKRHUD and may not be copied, imitated or used, in
            whole or in part, without our prior written permission. All other trademarks, registered
            trademarks, product names and company names or logos mentioned on our Services are the
            property of their respective owners. Reference to any products, services, processes or
            other information by trade name, trademark, manufacturer, supplier or otherwise does not
            constitute or imply endorsement, sponsorship or recommendation by us.
          </p>
        </article>
        <article class="feedback">
          <h3 class="title">11. Feedback</h3>
          <p>
            You may voluntarily post, submit or otherwise communicate to us any questions, comments,
            suggestions, ideas, original or creative materials or other information about SNKRHUD or
            our Services (collectively, "Feedback"). We may use such Feedback for any purpose,
            commercial or otherwise, without acknowledgment or compensation to you, including,
            without limitation, to develop, copy, publish, or improve the Feedback in SNKRHUD’s sole
            discretion. You understand that SNKRHUD may treat Feedback as nonconfidential.
          </p>
        </article>
        <article class="indemnification">
          <h3 class="title">12. Indemnification</h3>
          <p>
            To the fullest extent permitted by applicable law, you will indemnify, defend and hold
            harmless SNKRHUD and our subsidiaries and affiliates, and each of our respective
            officers, directors, agents, partners and employees (individually and collectively, the
            "SNKRHUD Parties") from and against any losses, liabilities, claims, demands, damages,
            expenses or costs ("Claims") arising out of or related to (a) your access to or use of
            our Services; (b) your Feedback; (c) your violation of these Terms or the Digital
            Collectible Terms; (d) your violation, misappropriation or infringement of any
            intellectual property, privacy, or other rights of another; or (e) your conduct in
            connection with our Services. You will cooperate with the SNKRHUD Parties in defending
            such Claims and pay all fees, costs and expenses associated with defending such Claims
            (including, but not limited to, attorneys' fees). SNKRHUD Parties will have control of
            the defense or settlement, at SNKRHUD’s sole option, of any third-party Claims.
          </p>
        </article>
        <article class="governing-law-and-venue">
          <h3 class="title">13. Governing Law and Venue</h3>
          <p>
            Any dispute arising from these Terms and your use of our Services will be governed by
            and construed and enforced in accordance with the laws of the State of New York without
            regard to conflict of law rules or principles that would cause the application of the
            laws of any other jurisdiction. Any dispute between the parties that is not subject to
            arbitration or cannot be heard in small claims court will be resolved in the state or
            federal courts located in the boroughs of Brooklyn (Kings County) or Manhattan (New York
            County) in the state of New York and you consent to jurisdiction and venue in such
            courts.
          </p>
        </article>
      </b-row>
      <!-- <b-row>
        <b-col>
          <img
            src="@/assets/rebrand/about/the-founders.png"
            alt="the founders"
            class="img-the-founders"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col />
        <b-col sm="5">
          <div class="divider -mb" />
          <img
            src="@/assets/rebrand/about/brandon-martinez.png"
            alt="brandon martinez"
            class="img-founder -wb"
          />
          <img
            src="@/assets/mobile/brandon-martinez.png"
            alt="brandon martinez"
            class="img-founder -mb"
            style="width: 83%;"
          />
        </b-col>
        <b-col sm="5">
          <div class="divider -mb" />
          <img
            src="@/assets/rebrand/about/stefan-tauber.png"
            alt="stefant auber"
            class="img-founder mtn8 -wb"
          />
          <img
            src="@/assets/mobile/stefan-tauber.png"
            alt="stefant auber"
            class="img-founder mtn8 -mb"
          />
        </b-col>
        <b-col />
      </b-row>
      <img src="@/assets/rebrand/about/about-div.png" alt="divider" class="divider -wb" />
      <b-row>
        <b-col />
        <b-col sm="5">
          <div class="divider -mb" />
          <img
            src="@/assets/rebrand/about/cameron-henry.png"
            alt="cameron henry"
            class="img-founder mt-3 -wb"
          />
          <img
            src="@/assets/mobile/cameron-henry.png"
            alt="cameron henry"
            class="img-founder -mb mtn8"
          />
        </b-col>
        <b-col sm="5">
          <img
            src="@/assets/rebrand/about/hiraya-mnl.png"
            alt="hiraya mnl"
            class="img-founder mt-3 -wb"
          />
          <img src="@/assets/mobile/hiraya-mnl.png" alt="hiraya mnl" class="img-founder -mb mtn8" />
        </b-col>
        <b-col />
      </b-row> -->
      <div class="founders-bg" />
      <img src="../assets/rebrand/about/ded-stock-1.png" class="asset-1 position-absolute" alt="" />
      <img src="../assets/rebrand/about/ded-stock-2.png" class="asset-2 position-absolute" alt="" />
      <img src="../assets/rebrand/about/ded-stock-3.png" class="asset-3 position-absolute" alt="" />
      <img src="../assets/rebrand/about/ded-stock-4.png" class="asset-4 position-absolute" alt="" />
      <img src="../assets/rebrand/about/ded-stock-5.png" class="asset-5 position-absolute" alt="" />
      <img src="../assets/rebrand/about/spider-web.png" class="asset-6 position-absolute" alt="" />
    </b-container>
  </main>
</template>
<script>
export default {
  name: 'AboutUs',
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/fontstyle.css";
@import "../assets/styles/privacy-policy.scss";
</style>
